import React, { useState } from 'react';
import '../styles/style.css'; // Importe seu CSS aqui
import Navbar from '../components/navbar'; // Importando o componente Navbar
import Footer from '../components/footer'; // Importando o componente Footer

const GranitePage = () => {
  // Estado para controlar a visibilidade do modal e a imagem exibida
  const [modalVisible, setModalVisible] = useState(false);
  const [modalImage, setModalImage] = useState('');

  // Função para abrir o modal com a imagem
  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
    setModalVisible(true);
  };

  // Função para fechar o modal
  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <div>
      {/* Modal */}
      {modalVisible && (
        <div id="imageModal" className="modal">
          <span className="modal-close" onClick={closeModal}>&times;</span>
          <div className="modal-content">
            <img id="modalImage" src={modalImage} alt="Imagem do Modal" />
          </div>
        </div>
      )}

      <Navbar />

      {/* Secção de Mármores e Granitos */}
      <section className="pedras" id="marmores">
        <h2 className="section-title">Mais Recomendados</h2>
        <div className="container">
          <div className="grid-container-granito">
            {[
              {
                src: "https://colourofstone.com/wp-content/uploads/AngolaBlack2-Kopie4.jpg",
                alt: "Mármore Angola",
                name: "Angola"
              },
              {
                src: "https://www.marmofoz.com/media/IMPORTACOES//CORES/G.NEGIMP/IMG//00.jpg",
                alt: "Mármore Impala",
                name: "Impala"
              },
              {
                src: "https://www.dimpomar.com/xms/img/1200x630/b63bb/cT05MCZmbHRyW109/L08zbS8tME0zWnJTbS95NHNnWjd1blpGc2E3akpTbS9aMG1qRnU3czBGWks4c0pTcm5qc1owbWpGdTdqdHp0ZGty.jpg",
                alt: "Mármore Negro Absoluto",
                name: "Negro Absoluto"
              },
              {
                src: "https://pedralinda.com/wp-content/webpc-passthru.php?src=https://pedralinda.com/wp-content/uploads/2021/04/azul_lavrador_claro.jpg&nocache=1",
                alt: "Mármore Azul Lavrador",
                name: "Azul Lavrador"
              },
              {
                src: "https://www.marmorariagranineus.com.br/img/pedras/granitos/granito-verde-labrador.jpg",
                alt: "Mármore Verde Lavrador",
                name: "Verde Lavrador"
              },
              {
                src: "https://granitosdeportugal.pt/wp-content/uploads/2019/11/granito-preto-favaco.jpg",
                alt: "Mármore Favaco",
                name: "Favaco"
              },
              {
                src: "https://www.marmofoz.com/api/ImageHandler.ashx?foto=00.jpg&artigo=51552&type=custom&w=1024&pasta=/CORES/G.PEDSAL/IMG/",
                alt: "Mármore Pedras Salgadas",
                name: "Pedras Salgadas"
              },
              {
                src: "https://pedrasalexandreecatarino.com/wp-content/uploads/2020/03/Granito-Cinza-%C3%89vora-480x480.png",
                alt: "Mármore Évora",
                name: "Évora"
              },
              {
                src: "https://pedrasalexandreecatarino.com/wp-content/uploads/2020/03/Granito-Cinza-Serpa.jpg",
                alt: "Mármore Serpa",
                name: "Serpa"
              },
              {
                src: "https://granitosdeportugal.pt/wp-content/uploads/2019/10/granitopretozimbabwe-1.jpg",
                alt: "Mármore Zimbabwe",
                name: "Zimbabwe"
              }
            ].map((stone, index) => (
              <div className="pedra-item" key={index} onClick={() => openModal(stone.src)}>
                <img src={stone.src} alt={stone.alt} />
                <div className="info">
                  <h3>{stone.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Granitos Nacionais */}
      <section className="pedras" id="granitos-nacionais">
        <h2 className="section-title">Granitos Nacionais</h2>
        <div className="container">
          <div className="grid-container-granito-nacionais">
            {[
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/amarelo-sao-martinho-800x600-q70.webp",
                alt: "Granito Amarelo Vila Real",
                name: "Amarelo Vila Real"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/amarelo-sao-martinho-800x600-q70.webp",
                alt: "Granito Amarelo S. Martinho",
                name: "Amarelo S. Martinho"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/cinzento-evora-800x600-q70.webp",
                alt: "Granito Cinza Évora",
                name: "Cinza Évora"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/gran-santaeulalia-1-800x600-q70.webp",
                alt: "Granito Santa Eulália",
                name: "Santa Eulália"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/granito_white_silver-800x600-q70.webp",
                alt: "Granito Cinzeto White Silver",
                name: "Cinzeto White Silver"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/rosa-moncao-1-800x600-q70.webp",
                alt: "Granito Rosa Monção",
                name: "Rosa Monção"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/rosa-porrino-800x600-q70.webp",
                alt: "Granito Rosa Porrino",
                name: "Rosa Porrino"
              },
              {
                src: "https://www.marmoramos.pt/thumbs/pedras-naturais/granitos/rosa-monforte-800x600-q70.webp",
                alt: "Granito Rosa Monforte",
                name: "Rosa Monforte"
              }
            ].map((stone, index) => (
              <div className="pedra-item" key={index} onClick={() => openModal(stone.src)}>
                <img src={stone.src} alt={stone.alt} />
                <div className="info">
                  <h3>{stone.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GranitePage;
